import React, { Component } from 'react';
import Slider from 'react-slick';
import { portfolioSlick2 } from './script';
import Rating from '@material-ui/lab/Rating';
import Box from '@material-ui/core/Box';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import { withStyles } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
import { Col, Form, InputGroup, Button } from 'react-bootstrap';

const styles = theme => ({
	modal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	review: {
		border: '2px solid #000',
		backgroundColor: 'white',
		width: '100vh',
		boxShadow: 'black 0px 0px 20px 5px',
		height: '80vh',
	},
	paperCareer: {
		borderRadius: '10px',
		boxShadow: 'black 0px 0px 20px 5px',
		backgroundColor: 'white',
		width: '90vh',
		height: '60vh',
	},
});

const PortfolioList = [
	{
		rating: 4,
		image: 'image-1',
		category: 'Derek S.',
		area: 'Langley to Vancouver',
		title:
			'Well, our move happened this past Saturday, and we just had to let you know…..the guys you sent were amazing! Thank you so much! They were polite, efficient and careful. They really took the stress out of our move and we would gladly recommend them and your company to everybody! The whole experience with your company was great. ',
	},
	{
		rating: 5,
		image: 'image-2',
		category: 'Selena M.',
		area: 'Vancouver to Burnaby',
		title: 'Hello. Thank you so much for easing the stress of moving day. Ben and Ken were friendly, fast, efficient, and careful. The whole experience was far better then I could have imagined. I will not hesitate to recommend your company. Thank you! Cheers',
	},
	{
		rating: 4,
		image: 'image-3',
		category: 'Eric F.',
		area: 'Coquitlam to Burnaby',
		title: 'Hi, I just wanted to let you know that the move you guys did for me on Saturday, was hands down the best moving job anyone has ever done for me (and I’ve moved a lot!). Thank you very much for all your help and I will be sure to call you again if I have to move in the future.',
	},
	{
		rating: 5,
		image: 'image-4',
		category: 'John C.',
		area: 'Surrey to Vancouver',
		title:
			'I personally wanted to thank Moonline Moving. In this day and age its hard to find a business that gave me such good service. I had a 9 am booking, they showed up at 9 am sharp, and from the start they worked hard and never complained once, even though I had a ton of stuff. Even though moving can be stressful and hard I can honestly say it was an easy move considering everything, they made it easy. So thanks guys,',
	},
	{
		rating: 4,
		image: 'image-3',
		category: 'Luke H.',
		area: 'New Westminster to Mission',
		title: 'Hi, just wanted to say the movers did a horrible job!!! Just kidding. The move went perfect so thanks again for another great move.',
	},
	{
		rating: 4.5,
		image: 'image-1',
		category: 'Derek S.',
		area: 'Langley to Vancouver',
		title:
			'Well, our move happened this past Saturday, and we just had to let you know…..the guys you sent were amazing! Thank you so much! They were polite, efficient and careful. They really took the stress out of our move and we would gladly recommend them and your company to everybody! The whole experience with your company was great. ',
	},
	{
		rating: 4,
		image: 'image-3',
		category: 'Muke H.',
		area: 'New Westminster to Mission',
		title: 'Hi, just wanted to say the movers did a horrible job!!! Just kidding. The move went perfect so thanks again for another great move.',
	},
];

class portfolio extends Component {
	constructor(props) {
		super();
		this.state = {
			value: '',
			OpenForm: false,
			subscriptionFOrm: {
				firstName: '',
				lastName: '',
				email: '',
				phoneNumber: '',
				rating:0
			},
		};
	}

	submitAddReview = e => {
		e.preventDefault();
		this.setState({
            openCupon: true,
            OpenModal: false,
            OpenForm: false
		});
	};
	ratingFormChangeHandler = (name, value) => {
		this.setState(prevState => {
			return { subscriptionFOrm: { ...prevState.submitSubscription, [name]: value } };
		});
	};

	handleOpenForm = () => {
		this.setState({ OpenForm: true });
	};
	handleCloseForm = () => {
		this.setState({ OpenForm: false });
	};

	render() {
		const { classes } = this.props;
		let title = 'Here’s what our customers have to say about our services',
			description = 'We are dedicated to providing moving services with the highest level of reliability and experience.';
		return (
			<React.Fragment>
				<div className='portfolio-wrapper'>
					<div className='container'>
						<div className='row'>
							<div className='col-lg-12'>
								<div className='section-title'>
									<h2 style={{ fontSize: '45px' }}>{title}</h2>
									<p style={{ fontSize: '25px' }}>{description}</p>
								</div>
							</div>
						</div>
					</div>
					<div className='portfolio-slick-activation mt--70 mt_sm--40 '>
						<Slider {...portfolioSlick2}>
							{PortfolioList.map((value, index) => (
								<div className='portfolio' key={index}>
									<div className='thumbnail-inner'>
										<div className={`thumbnail ${value.image}`}></div>
										<div className={`bg-blr-image ${value.image}`}></div>
									</div>
									<div className='content'>
										<div className='inner'>
											<div class='row' style={{ marginBottom: '0vh' }}>
												<div class='col text-center' style={{ paddingLeft: '0' }}>
													<Box component='fieldset' mb={3} borderColor='transparent'>
														<Rating name='read-only' value={value.rating} readOnly />
													</Box>
												</div>
											</div>
											<h4>{value.category}</h4>
											<h5>{value.area}</h5>
											<a style={{ color: 'rgb(103, 103, 103)' }}>{value.title}</a>
										</div>
									</div>
								</div>
							))}
						</Slider>
					</div>
					<div className='row mt--80'>
						<div className='text-center col-lg-12 '>
							<button onClick={this.handleOpenForm} className='rn-btn' style={{ width: '20rem', fontSize: '22px', height: '7vh' }}>
								Give us a review
							</button>
							<Modal
								aria-labelledby='transition-modal-title'
								aria-describedby='transition-modal-description'
								className={classes.modal}
								open={this.state.OpenForm}
								onClose={this.handleCloseForm}
								closeAfterTransition
								BackdropComponent={Backdrop}
								BackdropProps={{
									timeout: 500,
								}}>
								<Fade in={this.state.OpenForm}>
									<div className={classes.paperCareer}>
										<div className='text-center'>
											<h3 style={{ fontSize: '30px', marginTop: '2rem' }} id='transition-modal-title'>
												Give Us a Review
											</h3>
										</div>
										<Form onSubmit={this.submitAddReview} style={{ paddingLeft: '18vh', paddingRight: '18vh' }}>
											<Form.Row>
												<Form.Group as={Col} controlId='formGridEmail' style={{marginLeft:'0'}}>
													<Form.Label>First Name</Form.Label>
													<Form.Control type='text' name="firstName" value={this.state.subscriptionFOrm.firstName} onChange={e => this.ratingFormChangeHandler(e.target.name, e.target.value)} placeholder='Enter your First Name' />
												</Form.Group>

												<Form.Group as={Col} controlId='formGridEmail' style={{marginLeft:'0'}}>
													<Form.Label>Last Name</Form.Label>
													<Form.Control type='text' name="lastName" value={this.state.subscriptionFOrm.lastName} onChange={e => this.ratingFormChangeHandler(e.target.name, e.target.value)} placeholder='Enter your First Name' />
												</Form.Group>
											</Form.Row>

											<Form.Row>
												<Form.Group as={Col} controlId='formGridEmail' style={{marginLeft:'0'}}>
													<Form.Label>Email</Form.Label>
													<Form.Control type='email' name="email" value={this.state.subscriptionFOrm.email} onChange={e => this.ratingFormChangeHandler(e.target.name, e.target.value)} placeholder='Enter email' />
												</Form.Group>

												<Form.Group as={Col} controlId='formGridEmail' style={{marginLeft:'0'}}>
													<Form.Label>Phone Number</Form.Label>
													<Form.Control type='text' name="phoneNumber"  value={this.state.subscriptionFOrm.phoneNumber} onChange={e => this.ratingFormChangeHandler(e.target.name, e.target.value)}  placeholder='Enter Phone Number' />
												</Form.Group>
											</Form.Row>
											<Form.Group as={Col} controlId='formGridEmail' style={{ padding: '0',paddingTop:'2vh',textAlignLast: 'center',marginLeft:'0vh'}}>
											<Rating name='rating' onChange={e=>this.ratingFormChangeHandler(e.target.name, e.target.value)} value={this.state.subscriptionFOrm.rating} />
											</Form.Group>
											<div className='text-center pt--0'>
												<Button variant='primary' type='submit' style={{ width: '13rem', background: '#de2828' }}>
													Submit
												</Button>
												<h5 style={{ fontSize: '12px', position: 'absolute', bottom: '0%', left: '34%' }}>We work very hard to serve our clients, please give us 24-48 hours to call you back</h5>
											</div>
										</Form>
									</div>
								</Fade>
							</Modal>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}
export default withStyles(styles)(portfolio);
